module.exports = __webpack_public_path__ + "static/img/manual-28.fb58545.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-28.png
// module id = L5BX
// module chunks = 4